var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "image": _vm.header.image,
      "debug": _vm.header.debug,
      "hasInstructions": _vm.instruction ? true : false,
      "instructionPictures": _vm.instruction.pictures,
      "instructionText": _vm.instruction.text,
      "instructionTitle": _vm.instruction.title
    }
  }, [_c('v-row', {
    attrs: {
      "fill-height": ""
    }
  }, [_vm.files.length < 1 ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "sm": "6",
      "xs": "6"
    }
  }, [_c('file-example', {
    attrs: {
      "example": _vm.example
    }
  })], 1) : _vm._e(), _vm._l(_vm.files, function (item, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "6",
        "md": "6",
        "sm": "6",
        "xs": "6"
      }
    }, [_c('file-upload', {
      attrs: {
        "item": item
      },
      on: {
        "deleted": _vm.deleted
      }
    })], 1);
  }), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "sm": "6",
      "xs": "6"
    }
  }, [_c('image-upload-button', {
    attrs: {
      "isUploaded": _vm.isUploaded,
      "isLoading": _vm.isLoading
    },
    on: {
      "click": _vm.click
    }
  })], 1)], 2), _vm.isPdfUploadEnabled ? _c('v-dialog', {
    staticClass: "pdfViewContainer",
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closePdfDialog.apply(null, arguments);
      }
    },
    model: {
      value: _vm.pdfDialog,
      callback: function callback($$v) {
        _vm.pdfDialog = $$v;
      },
      expression: "pdfDialog"
    }
  }, [_c('v-card', [_c('v-app-bar', {
    staticClass: "dialogBar",
    attrs: {
      "app": "",
      "floating": "",
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closePdfDialog
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm.pdfDialog && _vm.pdf ? _c('pdf-viewer', {
    attrs: {
      "pdf": _vm.pdf
    },
    on: {
      "onImageExport": _vm.onImageExport
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _c('input', {
    ref: "uploader",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-test-cockpit-image-upload": "",
      "name": "file",
      "type": "file",
      "accept": this.isPdfUploadEnabled ? 'image/x-png,image/jpeg,image/jpg,.jpg,.jpeg,.png, application/pdf, .pdf' : 'image/x-png,image/jpeg,image/jpg,.jpg,.jpeg,.png'
    },
    on: {
      "change": _vm.onFileInputEvent
    }
  }), _vm.isCameraDialogActive ? _c('camera-dialog', {
    ref: "dialog",
    attrs: {
      "instruction": _vm.instruction,
      "asset": _vm.asset,
      "handleUploadCb": _vm.handleUpload,
      "handleDeleteCb": _vm.handleDelete,
      "images": _vm.files.map(function (file) {
        return file.file;
      })
    },
    on: {
      "close-camera-dialog": function closeCameraDialog($event) {
        _vm.isCameraDialogActive = false;
      }
    }
  }) : _vm._e(), _c('camera-bottom-sheet', {
    ref: "sheet",
    on: {
      "camera-clicked": function cameraClicked($event) {
        _vm.isCameraDialogActive = true;
      },
      "library-clicked": function libraryClicked($event) {
        return _vm.$refs.uploader.click();
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }